import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import Skeleton from "react-loading-skeleton";
import { ApiCall } from "../../../../helper/axios";
import { getUserToken } from "../../../../helper/commonFunction";
import { useNavigate } from "react-router-dom";
import moment from "moment/moment.js";
import { useGetHotelStaticData } from "../../hooks/useGetHotelStaticData";

const settings = {
  dots: false,
  infinite: false,
  arrows: false,
  speed: 600,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 479,
      settings: {
        slidesToShow: 1.5,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
  ],
};
let regions = [{ name : "Italy",id : 965835257},{ name : "Japan", id : 3593},{ name : "Maldives", id : 109},{ name : "United Kingdom", id : 2114},{ name : "Russia", id : 2395},{ name : "Dubai", id : 6053839},{ name : "Paris", id : 2734}]
export const HotelExplore = () => {
  const [exploreData, setExploreData] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const checkinDate  = moment().format("YYYY-MM-DD");
  const checkoutDate = moment().add(1, 'days').format("YYYY-MM-DD");

  const navigateToList = (name) => {
    const cityId = regions?.find(r => r?.name?.toLowerCase() === name?.toLowerCase())?.id
    const searchData = encodeURIComponent(btoa(unescape(encodeURIComponent(JSON.stringify({name,fullRegionName:name,code:cityId,country:name,rateHawkCityCode:cityId})))));
    const url = `/hotels/list?checkinDate=${checkinDate}&checkoutDate=${checkoutDate}&cid=${cityId}&hid=${""
      }&ris=${[{
        noOfAdult: 1,
        noOfChild: 0,
        childAges: [],
      }]?.map(
          (r) =>
            `${r?.noOfAdult}n${r?.noOfChild}${r?.childAges?.length > 0
              ? `n${r?.childAges?.map((d) => (!d ? 1 : d))?.join("a")}`
              : ""
            }`
        )
        .join("_")}&residence=AE&nationality=${"88"}${`&keyword=${name}`}&searchData=${searchData}`;
    navigate(url, {
      state: new Date().getTime(),
    });
  }
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const resppnse = await ApiCall('GET', `wp-json/dahrHotelApi/v1/exploreCountries?userToken=${getUserToken()}`, {}, {}, 'wordpress')
      setExploreData(resppnse?.data);
      setLoading(false);
    }
    fetchData();
  }, []);
  return (
    <div className="hw-countryExplore--section hw-pt--medium">
      <div className="hw-page--width">
        <h2 className="h3 text-center mb-20">Explore Countries</h2>
        {loading ? (
          <div className="row">
            <div className="col-3">
              <Skeleton width={"20vw"} height={"140px"} />
            </div>
            <div className="col-3">
              <Skeleton width={"20vw"} height={"140px"} />
            </div>
            <div className="col-3">
              <Skeleton width={"20vw"} height={"140px"} />
            </div>
            <div className="col-3">
              <Skeleton width={"20vw"} height={"140px"} />
            </div>
          </div>
        ) : (
          <Slider {...settings}>
            {exploreData?.map?.((d) => {
              return (
                d?.image && (
                  <div className="hw-countryExplore--slideItem">
                    <a onClick={() => navigateToList(d?.name)}>
                      <div className="hw-countryExplore--slideItem__image">
                        <img src={d?.image} alt="Country" />
                      </div>
                      <div className="hw-countryExplore--slideItem__dt">{d?.name}</div>
                    </a>
                  </div>
                )
              );
            })}
          </Slider>
        )}
      </div>
    </div>
  );
};
